<div class="userDetailContainer animateH5">
    <div class="header hdr">
        <div class="d-flex">
            <h5 class="animateClass"> <span class="animateH5">{{userDetailInput?.name}}</span>
            </h5>
            <ul class="list-group list-group-horizontal IconClass" *ngIf="!passwordFormShow">
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 102 || userId === userId2"
                        [ngClass]="userDetailInput?.role === 102 || userId === userId2 ? 'disableClass':''"
                        *ngIf="userDetailInput?.active === 'Y'" class="listIcon" tooltip="Deactivate"
                        [options]="myOptions">
                        <i class="fa fa-ban" aria-hidden="true"
                        data-bs-toggle="modal" data-bs-target="#userDeActiveModal"></i>
                    </a>
                    <a [attr.disabled]="userDetailInput?.role === 102 || userId === userId2"
                        [ngClass]="userDetailInput?.role === 102 || userId === userId2 ? 'disableClass':''"
                        *ngIf="userDetailInput?.active === 'N'" class="listIcon" tooltip="Activate"
                        [options]="myOptions">
                        <i class="fa fa-check" aria-hidden="true" (click)="deactivateUserFun(userDetailInput)"
                       ></i>
                    </a>
                </li>
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 102 || userId === userId2"
                        [ngClass]="userDetailInput?.role === 102 || userId === userId2 ? 'disableClass':''"
                        class="listIcon" tooltip="Reset Password" [options]="myOptions">
                        <i class="fa fa-lock" aria-hidden="true" (click)="openPasswordForm()"></i></a>
                </li>
                <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 102 || userId === userId2"
                        [ngClass]="userDetailInput?.role === 102 || userId === userId2 ? 'disableClass':''"
                        aria-disabled="true" class="listIcon" tooltip="Delete" [options]="myOptions">
                        <i class="fa fa-trash" aria-hidden="true" (click)="deleteUserFun(userDetailInput)"
                            data-bs-toggle="modal" data-bs-target="#exampleModal"></i></a>
                </li>
            </ul>
        </div>
    </div>
    <form [formGroup]="userDetailsForm" autocomplete="off" *ngIf="!passwordFormShow">
        <div class="container userFormContainer">
            <div class="row">
                <div class="col-md-8 offset-md-2">
                    <div class="card userDetailsCard">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="userHeading border">User Details</h4>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Name <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="text" class="form-control" formControlName="name" name="name"
                                        id="name">
                                        <span class="text-danger"
                                        *ngIf="userDetailsForm.controls['name'].value !='' && userDetailsForm.controls['name'].invalid && userDetailsForm.controls['name'].dirty">
                                        Enter valid user name. </span>  
                                        <span class="text-danger"
                                        *ngIf="userDetailsForm.controls['name'].hasError('required') && userDetailsForm.controls['name'].dirty">
                                        User name is required. </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">User Role <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <select *ngIf="!getRole" type="text" class="{{adminClass}} select1"
                                        formControlName="role" name="role" id="role">
                                        <option value="" selected hidden>Supervisor</option>
                                        <option value="100">Supervisor</option>
                                        <option value="101">User</option>
                                    </select>
                                    <select *ngIf="getRole" class="form-control select2" formControlName="role"
                                        name="role" id="role">
                                        <option value="" selected hidden>Admin</option>
                                        <option value="102">Admin</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Email <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="email" class="form-control" 
                                        formControlName="email" name="email" id="email" autocomplete="off">

                                        <span class="text-danger"
                                        *ngIf="userDetailsForm.controls['email'].hasError('required') && userDetailsForm.controls['email'].dirty">
                                        User email is required. </span>
                                        <span class="text-danger"
                                        *ngIf="userDetailsForm.controls['email'].value !='' && userDetailsForm.controls['email'].invalid  && userDetailsForm.controls['email'].hasError('pattern')">
                                        Enter valid user email. </span>  
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Phone Number <i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="tel" class="form-control" 
                                        formControlName="phoneno" name="phoneno" id="phoneno"  NoWhitespace>
                                </div>

                                <span class="text-danger"
                                *ngIf="userDetailsForm.controls['phoneno'].value =='' && userDetailsForm.controls['phoneno'].hasError('required') && userDetailsForm.controls['phoneno'].dirty">
                                User Phone Number is required. </span>
                                <span class="text-danger"
                                *ngIf="userDetailsForm.controls['phoneno'].hasError('pattern') && userDetailsForm.controls['phoneno'].invalid">
                                Enter valid phone number. </span> 
                            </div>
                            <div class="col-md-12 text-end">
                                <button class="btn btn-light cancelBtn" [disabled]="!userDetailsForm.dirty" type="button" (click)="goBack()">Reset</button>
                                <button class="btn btn-primary updateBtn" type="submit"
                                    [disabled]="!spinner && userDetailsForm.invalid && userDetailsForm.dirty" (click)="updateUserDetails()"><i
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                        <span class="sr-only">Loading...</span>
                                    </i>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- password reset form -->
    <form [formGroup]="passwordForm" *ngIf="passwordFormShow">
        <div class="container userFormContainer">
            <div class="row">
                <div class="col-md-6 offset-md-2">
                    <div class="card userDetailsCard">
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="userHeading">Password Reset</h4>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel"
                                        [ngClass]="{ 'is-invalid': submitted && f['password'].errors }">New Password<i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <div class="input-field">
                                        <input [type]="type" class="form-control" formControlName="password"
                                            name="password" id="password">
                                        <span class="fa {{eyeIcon}} passwordEye" (click)="hideShowPassword()"></span>
                                    </div>
                                    <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
                                        <div class="text-danger"
                                            *ngIf="f['password'].errors['required'] && f['password'].invalid">New
                                            password is required</div>
                                        <div class="text-danger" *ngIf="f['password'].errors['minlength']">
                                            Password must be at least 8 characters
                                        </div>
                                        <div class="text-danger" *ngIf="f['password'].errors['pattern']">Password must
                                            contain a number and At least 1 character from ( _, &#64;, or $).</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="form-label mandatoryLabel">Confirm Password<i
                                            class="fa-solid fa-asterisk mandatoryIcon"></i></label>
                                    <input type="password"
                                        [ngClass]="{ 'is-invalid': submitted && f['confirmPassword'].errors && f['confirmPassword'].invalid}"
                                        class="form-control" formControlName="confirmPassword" name="confirmPassword"
                                        id="confirmPassword">
                                    <div class="text-danger"
                                        *ngIf="submitted && f['confirmPassword'].errors && f['confirmPassword'].invalid"
                                        class="invalid-feedback">
                                        <div class="text-danger"
                                            *ngIf="f['confirmPassword'].errors['required'] && f['confirmPassword'].invalid">
                                            Confirm password is required
                                        </div>
                                        <div class="text-danger" *ngIf="f['confirmPassword'].errors['matching']">
                                            Passwords do not match. Please re-enter your password.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-end">
                                <button class="btn btn-light cancelBtn" type="button"
                                    (click)="hidePasswordForm()">Cancel</button>
                                <button class="btn btn-primary updateBtn" type="submit"
                                    [disabled]="!passwordForm.dirty && !spinner" (click)="onSubmit()"><i
                                        class="fa fa-spinner fa-pulse fa-3x fa-fw" *ngIf="spinner">
                                        <span class="sr-only">Loading...</span>
                                    </i>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- delete modal -->
    <div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="exampleModalLabel">Delete User</h4>
                    <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    Are you sure, you want to delete?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                    <button type="button" class="btn btn-danger" (click)="deleteUserEmitFun(getDeleteUserData)"
                        data-bs-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>

      <!-- user De Active modal -->
      <div class="modal fade deleteModal" id="userDeActiveModal" tabindex="-1" aria-labelledby="userDeActiveModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title" id="exampleModalLabel">Alert</h4>
                  <i class="fa-solid fa-xmark exitIcon" data-bs-dismiss="modal" aria-label="Close"></i>
              </div>
              <div class="modal-body">
                  Are you sure, you want to De-Activate User?
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                  <button type="button" class="btn btn-danger" (click)="deactivateUserEmitFun(userDetailInput)"
                      data-bs-dismiss="modal">Yes</button>
              </div>
          </div>
      </div>
  </div>